const downloadAsCSV = (data: string, filename: string = "data.csv") => {
    const blob = new Blob([data], { type: "text/csv" });

    // This URL can then be used to initiate a file download in the browser
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url ?? "#";
    a.download = filename;
    a.click();

    a.remove();
};

export default downloadAsCSV;
